import { StoreQueryType } from "@common/utils/use-query";
import { migrationStore } from "@stores/migration";
import { useRouter } from "next/router";
import { useMemo } from "react";

interface IUseIsValidMigrationIdRes
  extends Pick<StoreQueryType, "isLoading" | "error"> {
  migrationId?: string;
  isValid: boolean;
}

export default function useIsValidMigrationId(): IUseIsValidMigrationIdRes {
  const router = useRouter();
  const { query } = router;
  const { "migration-id": rawMigrationId } = query;

  const migrationId = useMemo(
    () => (rawMigrationId ? String(rawMigrationId) : undefined),
    [rawMigrationId],
  );

  const { isLoading, error } = migrationStore.useValidMigration(
    migrationId || "",
    { enabled: !!migrationId },
  );

  return {
    isLoading,
    error,
    migrationId,
    isValid: !!(migrationId && !isLoading && !error),
  };
}
